import ReactDOM from "react-dom";

import "./index.css";

import * as Sentry from "@sentry/browser";

import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";

import App from "./App";
import { DSN, inDev, inStaging } from "./config.js";
import { FPAlertProvider } from "./AlertProvider";
import { store } from "./store";

Sentry.init({
  dsn: DSN,
  enabled: inDev === false,
  environment: inStaging ? "staging" : "production",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
});

const Root = () => (
  <Provider store={store}>
    <FPAlertProvider>
      <App />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#23303E",
            color: "#FFFFFF",
          },
        }}
      />
    </FPAlertProvider>
  </Provider>
);

async function enableMocking() {
  // Only enable mocking in development
  if (process.env.NODE_ENV !== "development") {
    return;
  }

  // Check if MSW should be enabled (you can use an environment variable or feature flag)
  const enableMSW = localStorage.getItem("enableMSW") === "true";

  if (!enableMSW) {
    return;
  }

  const { worker } = await import("./mocks/browser");

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
}

enableMocking().then(() => {
  ReactDOM.render(<Root />, document.getElementById("root"));
});
